var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.183 5.363a.507.507 0 0 0-.348.136.452.452 0 0 0-.145.33v2.788a.452.452 0 0 1-.144.329.507.507 0 0 1-.348.136H3.292a.507.507 0 0 1-.348-.136.452.452 0 0 1-.144-.329V3.04c0-.123.052-.241.144-.329a.507.507 0 0 1 .348-.136h2.953c.13 0 .256-.049.348-.136a.452.452 0 0 0 .144-.329.452.452 0 0 0-.144-.328.507.507 0 0 0-.348-.136H3.292c-.392 0-.767.146-1.044.408a1.356 1.356 0 0 0-.433.986v5.578c0 .37.156.725.433.986.277.262.652.409 1.044.409h5.906c.392 0 .767-.147 1.044-.409.277-.261.433-.616.433-.986V5.828a.452.452 0 0 0-.144-.329.507.507 0 0 0-.348-.136z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.214 2.574h.777l-3.095 2.92a.464.464 0 0 0-.146.33.443.443 0 0 0 .146.33.495.495 0 0 0 .349.137.517.517 0 0 0 .35-.137l3.095-2.92v.735c0 .123.052.241.145.328a.507.507 0 0 0 .347.137c.131 0 .256-.05.349-.137a.452.452 0 0 0 .144-.328v-1.86a.452.452 0 0 0-.144-.328.507.507 0 0 0-.349-.136H8.214a.507.507 0 0 0-.348.136.452.452 0 0 0-.144.328c0 .124.051.242.144.33a.507.507 0 0 0 .348.135z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlink);
export default __webpack_public_path__ + "static/media/outlink.09b8c7b849346d381b4938a718760ac0.svg";
export { ForwardRef as ReactComponent };